//#region Libraries
import styled from "styled-components";
//#endregion

export const Container = styled.span`
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;
    svg { transition: 0.4s; }
    &.opened svg {
        transform: rotate(180deg);
    }
`;